// src/components/Footer.jsx
import { Link } from 'react-router-dom';

const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'Capabilities', path: '/capabilities' },
  { label: 'Workforce', path: '/workforce' },
  { label: 'Government & RFPs', path: '/government-rfps' },
  { label: 'Careers', path: '/careers' },
  { label: 'About', path: '/about' },
  { label: 'Contact', path: '/contact' },
];

function LogoIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="16" fill="#154DDE"/>
      <path d="M20.666 7.407V11.974C20.666 12.076 20.661 12.177 20.652 12.276C20.649 12.31 20.646 12.343 20.641 12.376C20.436 14.066 19.003 15.368 17.262 15.368V10.801C17.262 8.944 18.789 7.407 20.666 7.407Z" fill="white"/>
      <path d="M20.666 24.593L14.601 24.593C11.086 24.593 8.237 21.756 8.237 18.257C8.237 16.507 8.939 14.921 10.08 13.762C11.222 12.609 12.812 11.887 14.577 11.887L16.368 11.89V15.059H14.699C13.875 15.059 13.127 15.394 12.579 15.939C12.021 16.492 11.674 17.258 11.684 18.097C11.702 19.731 13.091 21.053 14.738 21.053H17.58C19.082 21.053 20.343 22.107 20.646 23.522C20.694 23.742 20.719 23.968 20.719 24.2C20.719 24.331 20.701 24.463 20.666 24.593Z" fill="white"/>
      <path d="M20.666 15.983V22.447C20.502 22.253 20.317 22.075 20.116 21.916C19.391 21.33 18.473 20.986 17.513 20.986H17.262V16.734C18.643 16.734 19.882 16.056 20.666 15.983Z" fill="white"/>
    </svg>
  );
}

function FacebookIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
    </svg>
  );
}

function InstagramIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
      <circle cx="12" cy="12" r="3.5"/>
      <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
    </svg>
  );
}

function XIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
    </svg>
  );
}

function LinkedInIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z"/>
      <circle cx="4" cy="4" r="2"/>
    </svg>
  );
}

function YoutubeIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 0 0-1.95 1.96A29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58A2.78 2.78 0 0 0 3.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.95A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/>
      <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="white"/>
    </svg>
  );
}

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__top">
          {/* Logo */}
          <div className="footer__logo">
            <LogoIcon />
            <div className="footer__logo-text">
              <div>District</div>
              <div>Sourcing Tech</div>
            </div>
          </div>

          {/* Nav Links */}
          <nav className="footer__links">
            {NAV_LINKS.map(({ label, path }) => (
              <Link key={path} to={path} className="footer__link">{label}</Link>
            ))}
          </nav>

          {/* Social */}
          <div className="footer__social">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook"><FacebookIcon /></a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram"><InstagramIcon /></a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="X (Twitter)"><XIcon /></a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="LinkedIn"><LinkedInIcon /></a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="YouTube"><YoutubeIcon /></a>
          </div>
        </div>

        <div className="footer__divider" />

        <div className="footer__bottom">
          <p className="footer__credits">
            © 2025 <strong>District Sourcing Tech Pvt. Ltd</strong>. All rights reserved.
          </p>
          <div className="footer__legal">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-of-service">Terms of Service</Link>
            <Link to="/cookies">Cookies Settings</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}